import html2PDF from "jspdf-html2canvas";

class ClampingDistance {
    constructor() {
        this.$ = jQuery;
        // this.data = clampingData;  // Använd JSON-datan direkt
        this.data = {
            "ECTFE": {
                "20": { "20": 530, "30": 510, "40": 490, "50": 470, "60": 450, "70": 430, "80": 410, "90": 380, "100": 340 },
                "25": { "20": 580, "30": 560, "40": 540, "50": 520, "60": 500, "70": 470, "80": 450, "90": 420, "100": 380 },
                "32": { "20": 680, "30": 660, "40": 640, "50": 610, "60": 580, "70": 560, "80": 530, "90": 490, "100": 440 },
                "50": { "20": 870, "30": 840, "40": 810, "50": 780, "60": 740, "70": 710, "80": 680, "90": 620, "100": 560 },
                "63": { "20": 950, "30": 910, "40": 880, "50": 850, "60": 810, "70": 770, "80": 740, "90": 680, "100": 610 },
                "90": { "20": 1200, "30": 1160, "40": 1120, "50": 1080, "60": 1030, "70": 980, "80": 940, "90": 870, "100": 780 },
                "110": { "20": 1380, "30": 1330, "40": 1290, "50": 1240, "60": 1180, "70": 1120, "80": 1050, "90": 990, "100": 890 }
            },
            "CPVC": {
                "16": { "20": 925, "30": 879, "40": 833, "50": 787, "60": 694, "70": 625, "80": 555, "90": 462 },
                "20": { "20": 1064, "30": 1018, "40": 949, "50": 879, "60": 810, "70": 717, "80": 648, "90": 555 },
                "25": { "20": 1111, "30": 1064, "40": 1018, "50": 925, "60": 833, "70": 740, "80": 648, "90": 555 },
                "32": { "20": 1250, "30": 1157, "40": 1111, "50": 1018, "60": 925, "70": 833, "80": 740, "90": 648 },
                "40": { "20": 1500, "30": 1400, "40": 1300, "50": 1250, "60": 1150, "70": 1050, "80": 900, "90": 800 },
                "50": { "20": 1650, "30": 1600, "40": 1500, "50": 1400, "60": 1300, "70": 1200, "80": 1100, "90": 900 },
                "63": { "20": 1850, "30": 1750, "40": 1650, "50": 1600, "60": 1500, "70": 1350, "80": 1250, "90": 1050 },
                "75": { "20": 2050, "30": 1950, "40": 1850, "50": 1750, "60": 1650, "70": 1500, "80": 1350, "90": 1200 },
                "90": { "20": 2250, "30": 2100, "40": 2000, "50": 1900, "60": 1800, "70": 1650, "80": 1500, "90": 1300 },
                "110": { "20": 2500, "30": 2350, "40": 2200, "50": 2100, "60": 1950, "70": 1800, "80": 1650, "90": 1450 },
                "125": { "20": 2650, "30": 2500, "40": 2350, "50": 2250, "60": 2100, "70": 1950, "80": 1750, "90": 1550 },
                "140": { "20": 2800, "30": 2650, "40": 2500, "50": 2350, "60": 2200, "70": 2050, "80": 1850, "90": 1650 },
                "160": { "20": 3000, "30": 2850, "40": 2700, "50": 2550, "60": 2400, "70": 2200, "80": 2000, "90": 1750 },
                "180": { "20": 3150, "30": 3000, "40": 2850, "50": 2700, "60": 2500, "70": 2300, "80": 2100, "90": 1850 },
                "200": { "20": 3350, "30": 3150, "40": 3000, "50": 2850, "60": 2650, "70": 2450, "80": 2200, "90": 1950 },
                "225": { "20": 3550, "30": 3350, "40": 3200, "50": 3000, "60": 2800, "70": 2600, "80": 2350, "90": 2100 },
                "250": { "20": 3750, "30": 3550, "40": 3350, "50": 3150, "60": 3000, "70": 2750, "80": 2500, "90": 2200 },
                "280": { "20": 3950, "30": 3750, "40": 3550, "50": 3350, "60": 3150, "70": 2900, "80": 2650, "90": 2350 },
                "315": { "20": 4200, "30": 4000, "40": 3750, "50": 3550, "60": 3350, "70": 3050, "80": 2800, "90": 2450 },
                "355": { "20": 4450, "30": 4250, "40": 4000, "50": 3800, "60": 3550, "70": 3250, "80": 2950, "90": 2650 },
                "400": { "20": 4750, "30": 4500, "40": 4250, "50": 4000, "60": 3750, "70": 3450, "80": 3150, "90": 2800 }
            },
            "PE": {
                "16": { "20": 500, "30": 450, "40": 450, "50": 400, "60": 350 },
                "20": { "20": 575, "30": 550, "40": 500, "50": 450, "60": 400 },
                "25": { "20": 650, "30": 600, "40": 550, "50": 550, "60": 500 },
                "32": { "20": 750, "30": 750, "40": 650, "50": 650, "60": 550 },
                "40": { "20": 900, "30": 850, "40": 750, "50": 750, "60": 650 },
                "50": { "20": 1050, "30": 1000, "40": 900, "50": 850, "60": 750 },
                "63": { "20": 1200, "30": 1150, "40": 1050, "50": 1000, "60": 900 },
                "75": { "20": 1350, "30": 1300, "40": 1200, "50": 1100, "60": 1000 },
                "90": { "20": 1500, "30": 1450, "40": 1350, "50": 1250, "60": 1150 },
                "110": { "20": 1650, "30": 1600, "40": 1500, "50": 1450, "60": 1300 },
                "125": { "20": 1750, "30": 1700, "40": 1600, "50": 1550, "60": 1400 },
                "140": { "20": 1900, "30": 1850, "40": 1750, "50": 1650, "60": 1500 },
                "160": { "20": 2050, "30": 1950, "40": 1850, "50": 1750, "60": 1600 },
                "180": { "20": 2150, "30": 2050, "40": 1950, "50": 1850, "60": 1750 },
                "200": { "20": 2300, "30": 2200, "40": 2100, "50": 2000, "60": 1900 },
                "225": { "20": 2450, "30": 2350, "40": 2250, "50": 2150, "60": 2050 },
                "250": { "20": 2600, "30": 2500, "40": 2400, "50": 2300, "60": 2100 },
                "280": { "20": 2750, "30": 2650, "40": 2550, "50": 2400, "60": 2200 },
                "315": { "20": 2900, "30": 2800, "40": 2700, "50": 2550, "60": 2350 },
                "355": { "20": 3100, "30": 3000, "40": 2900, "50": 2750, "60": 2550 },
                "400": { "20": 3300, "30": 3150, "40": 3050, "50": 2900, "60": 2700 },
                '450': { '20': 3700, '30': 3550, '40': 3350, '50': 3300, '60': 3100 },
                '500': { '20': 3950, '30': 3800, '40': 3550, '50': 3550, '60': 3350 },
                '560': { '20': 4250, '30': 4100, '40': 3850, '50': 3800, '60': 3550 },
                '630': { '20': 4550, '30': 4450, '40': 4200, '50': 4100, '60': 3850 },
                '710': { '20': 4950, '30': 4700, '40': 4500, '50': 4400, '60': 4250 },
                '800': { '20': 5350, '30': 5100, '40': 4900, '50': 4800, '60': 4550 },
                '900': { '20': 5750, '30': 5550, '40': 5300, '50': 5200, '60': 4950 },
                '1000': { '20': 6200, '30': 5900, '40': 5700, '50': 5600, '60': 5300 }
            },
            "PP": {
                "16": { "20": 650, "30": 625, "40": 600, "50": 575, "60": 550, "70": 525, "80": 500 },
                "20": { "20": 700, "30": 675, "40": 650, "50": 625, "60": 600, "70": 575, "80": 550 },
                "25": { "20": 800, "30": 775, "40": 750, "50": 725, "60": 700, "70": 675, "80": 650 },
                "32": { "20": 950, "30": 925, "40": 900, "50": 875, "60": 850, "70": 800, "80": 750 },
                "40": { "20": 1100, "30": 1075, "40": 1050, "50": 1000, "60": 950, "70": 925, "80": 875 },
                "50": { "20": 1250, "30": 1225, "40": 1200, "50": 1150, "60": 1100, "70": 1050, "80": 1000 },
                "63": { "20": 1450, "30": 1425, "40": 1400, "50": 1350, "60": 1300, "70": 1250, "80": 1200 },
                "75": { "20": 1550, "30": 1500, "40": 1450, "50": 1400, "60": 1350, "70": 1300, "80": 1250 },
                "90": { "20": 1650, "30": 1600, "40": 1550, "50": 1500, "60": 1450, "70": 1400, "80": 1350 },
                "110": { "20": 1850, "30": 1800, "40": 1750, "50": 1700, "60": 1600, "70": 1500, "80": 1400 },
                "125": { "20": 2000, "30": 1950, "40": 1900, "50": 1800, "60": 1700, "70": 1600, "80": 1500 },
                "140": { "20": 2100, "30": 2050, "40": 2000, "50": 1900, "60": 1800, "70": 1700, "80": 1600 },
                "160": { "20": 2250, "30": 2200, "40": 2100, "50": 2000, "60": 1900, "70": 1800, "80": 1700 },
                "180": { "20": 2350, "30": 2300, "40": 2200, "50": 2100, "60": 2000, "70": 1900, "80": 1800 },
                "200": { "20": 2500, "30": 2400, "40": 2300, "50": 2200, "60": 2100, "70": 2000, "80": 1900 },
                "225": { "20": 2650, "30": 2550, "40": 2450, "50": 2350, "60": 2250, "70": 2150, "80": 2000 },
                "250": { "20": 2800, "30": 2700, "40": 2600, "50": 2500, "60": 2400, "70": 2300, "80": 2150 },
                "280": { "20": 2950, "30": 2850, "40": 2750, "50": 2650, "60": 2550, "70": 2450, "80": 2300 },
                "315": { "20": 3150, "30": 3050, "40": 2950, "50": 2850, "60": 2700, "70": 2600, "80": 2450 },
                "355": { "20": 3350, "30": 3250, "40": 3150, "50": 3000, "60": 2850, "70": 2750, "80": 2600 },
                "400": { "20": 3550, "30": 3450, "40": 3350, "50": 3200, "60": 3050, "70": 2900, "80": 2750 },
                "450": { "20": 3800, "30": 3700, "40": 3600, "50": 3450, "60": 3300, "70": 3100, "80": 2950 },
                "500": { "20": 4100, "30": 4000, "40": 3850, "50": 3700, "60": 3500, "70": 3350, "80": 3150 },
                "560": { "20": 4400, "30": 4300, "40": 4150, "50": 4000, "60": 3800, "70": 3600, "80": 3400 },
                "630": { "20": 4800, "30": 4650, "40": 4500, "50": 4300, "60": 4100, "70": 3900, "80": 3700 }
            },
            "PVDF": {
                "16": { "20": 725, "30": 700, "40": 650, "50": 600, "60": 575, "70": 550, "80": 500, "90": 450 },
                "20": { "20": 850, "30": 800, "40": 750, "50": 750, "60": 700, "70": 650, "80": 600, "90": 450 },
                "25": { "20": 950, "30": 900, "40": 850, "50": 800, "60": 750, "70": 700, "80": 675, "90": 550 },
                "32": { "20": 1100, "30": 1050, "40": 1000, "50": 950, "60": 900, "70": 850, "80": 800, "90": 637 },
                "40": { "20": 1200, "30": 1150, "40": 1100, "50": 1050, "60": 1000, "70": 950, "80": 900, "90": 825 },
                "50": { "20": 1400, "30": 1350, "40": 1300, "50": 1200, "60": 1150, "70": 1100, "80": 1000, "90": 875 },
                "63": { "20": 1400, "30": 1350, "40": 1300, "50": 1250, "60": 1200, "70": 1150, "80": 1100, "90": 1025 },
                "75": { "20": 1500, "30": 1450, "40": 1400, "50": 1350, "60": 1300, "70": 1250, "80": 1200, "90": 1125 },
                "90": { "20": 1600, "30": 1550, "40": 1500, "50": 1450, "60": 1400, "70": 1350, "80": 1300, "90": 1200 },
                "110": { "20": 1800, "30": 1750, "40": 1700, "50": 1650, "60": 1550, "70": 1500, "80": 1450, "90": 1350 },
                "125": { "20": 1900, "30": 1850, "40": 1800, "50": 1700, "60": 1650, "70": 1600, "80": 1500, "90": 1425 },
                "140": { "20": 2000, "30": 1950, "40": 1900, "50": 1800, "60": 1750, "70": 1700, "80": 1600, "90": 1525 },
                "160": { "20": 2150, "30": 2100, "40": 2050, "50": 1950, "60": 1850, "70": 1800, "80": 1700, "90": 1625 },
                "180": { "20": 2300, "30": 2200, "40": 2150, "50": 2050, "60": 1950, "70": 1900, "80": 1800, "90": 1700 },
                "200": { "20": 2400, "30": 2350, "40": 2250, "50": 2150, "60": 2100, "70": 2000, "80": 1900, "90": 1800 },
                "225": { "20": 2550, "30": 2500, "40": 2400, "50": 2300, "60": 2200, "70": 2100, "80": 2000, "90": 1900 },
                "250": { "20": 2650, "30": 2600, "40": 2500, "50": 2400, "60": 2300, "70": 2200, "80": 2100, "90": 2000 },
                "280": { "20": 2850, "30": 2750, "40": 2650, "50": 2550, "60": 2450, "70": 2350, "80": 2250, "90": 2125 },
                "315": { "20": 3000, "30": 2950, "40": 2850, "50": 2750, "60": 2600, "70": 2500, "80": 2400, "90": 2275 },
                "355": { "20": 3200, "30": 3100, "40": 3000, "50": 2850, "60": 2750, "70": 2650, "80": 2500, "90": 2375 },
                "400": { "20": 3400, "30": 3300, "40": 3200, "50": 3050, "60": 2950, "70": 2800, "80": 2650, "90": 2525 }
            },
            "PVC": {
                "16": { "20": 950, "30": 900, "40": 850, "50": 750, "60": 600 },
                "20": { "20": 1100, "30": 1050, "40": 1000, "50": 900, "60": 700 },
                "25": { "20": 1200, "30": 1150, "40": 1050, "50": 950, "60": 750 },
                "32": { "20": 1350, "30": 1300, "40": 1250, "50": 1100, "60": 900 },
                "40": { "20": 1450, "30": 1400, "40": 1350, "50": 1250, "60": 1000 },
                "50": { "20": 1600, "30": 1550, "40": 1500, "50": 1400, "60": 1150 },
                "63": { "20": 1800, "30": 1750, "40": 1700, "50": 1550, "60": 1300 },
                "75": { "20": 2000, "30": 1900, "40": 1850, "50": 1700, "60": 1450 },
                "90": { "20": 2200, "30": 2100, "40": 2000, "50": 1850, "60": 1550 },
                "110": { "20": 2400, "30": 2300, "40": 2250, "50": 2050, "60": 1750 },
                "125": { "20": 2550, "30": 2450, "40": 2400, "50": 2200, "60": 1850 },
                "140": { "20": 2700, "30": 2600, "40": 2500, "50": 2300, "60": 1950 },
                "160": { "20": 2900, "30": 2800, "40": 2700, "50": 2500, "60": 2100 },
                "180": { "20": 3100, "30": 2950, "40": 2850, "50": 2650, "60": 2200 },
                "200": { "20": 3250, "30": 3150, "40": 3000, "50": 2800, "60": 2350 },
                "225": { "20": 3450, "30": 3300, "40": 3200, "50": 2950, "60": 2500 },
                "250": { "20": 3650, "30": 3500, "40": 3350, "50": 3100, "60": 2600 },
                "280": { "20": 3750, "30": 3700, "40": 3550, "50": 3300, "60": 2750 },
                "315": { "20": 4100, "30": 3900, "40": 3750, "50": 3500, "60": 2950 },
                "355": { "20": 4300, "30": 4200, "40": 4000, "50": 3700, "60": 3100 },
                "400": { "20": 4600, "30": 4450, "40": 4250, "50": 3950, "60": 3300 }
            }
        };
        //SDR-värden och f2 för olika material
        this.sdrData = {
            "ECTFE": { "33": 0.88, "21": 1.0 },
            "PE": { "33": 0.81, "26": 0.91, "17": 1.0, "11": 1.07, "7.4": 1.16 },
            "PP": { "33": 0.75, "26": 0.81, "17": 0.91, "11": 1.0, "7.4": 1.07 },
            "PVDF": { "33": 1.0, "21": 1.08 },
            "CPVC": { "21": 1.0, "13.6": 1.08 },
            "PVC": { "51": 0.91, "34.4": 0.94, "21": 1.0, "13.6": 1.09, "9": 1.22 }
        };
        this.f1Data = {  // Tabellen med f1-värden
            'ECTFE': { '33': 1.26, '21': 1.26 },
            'PVC': { '51': 1.55, '34.3': 1.51, '21': 1.42, '13.6': 1.29, '9': 1.1 },
            'CPVC': { '21': 1.4, '13.6': 1.27 },
            'PE': { '33': 1.55, '26': 1.45, '17': 1.3, '11': 1.21, '7.4': 1.18 },
            'PP': { '33': 1.65, '26': 1.55, '17': 1.45, '11': 1.3, '7.4': 1.21 },
            'PVDF': { '33': 1.48, '21': 1.36 }
        };


        this.init();
    }

    init() {
        this.loadMaterialData();  // Ladda materialdata direkt från den hårdkodade datan
        this.bindEvents();  // Bind event handlers
        this.disableSelectors();  // Inaktivera DN, temperatur och PN tills material är valt
    }

    disableSelectors() {
        this.$('#dn-select').prop('disabled', true);
        this.$('#temperature-select').prop('disabled', true);
        this.$('#sdr-select').prop('disabled', true).css('visibility', 'hidden'); // Dölj PN-dropdown
        this.$('#gas-checkbox-container').css('visibility', 'hidden');  // Dölj gas-checkbox
        this.$('#gas-f1-select-container').css('visibility', 'hidden');  // Dölj f1-dropdown för gas
    }

    resetSelections() {
        this.$('#dn-select').empty().prop('disabled', true);  // Rensa och inaktivera DN-dropdown
        this.$('#temperature-select').empty().prop('disabled', true);  // Rensa och inaktivera temperatur-dropdown
        this.$('#sdr-select').empty().prop('disabled', true).css('visibility', 'hidden');  // Dölj PN-dropdown
        this.$('#gas-checkbox-container').css('visibility', 'hidden');  // Dölj gas-checkbox vid reset
        this.$('#gas-f1-select-container').css('visibility', 'hidden');  // Dölj f1-dropdown för gas vid reset
        this.$('#rho-container').css('visibility', 'hidden');  // Dölj rho-input vid reset
        this.$('#clamping-result').val('');
        this.$('#table-clamp-value').val('');
        this.$('#f1-value').val('');
        this.$('#f2-value').val('');
    }
    loadMaterialData() {
        let $materialSelect = this.$('#material-select');

        // Lägg till en placeholder i dropdownen
        $materialSelect.append(`<option></option>`); // Placeholder alternativ

        // Lägg till materialalternativ från den hårdkodade datan
        Object.keys(this.data).forEach(material => {
            $materialSelect.append(`<option value="${material}">${material}</option>`);
        });

        // Initiera Select2 med placeholder
        $materialSelect.select2({
            placeholder: "Material",
            allowClear: true
        });
    }

    bindEvents() {
        let $ = this.$;

        const resetGasCheckbox = () => {
            $('#gas-checkbox').prop('checked', false); // Avmarkera checkboxen
            $('#gas-checkbox-container').css('visibility', 'hidden').css('display', 'none');  // Dölj gas-checkbox vid reset
            $('#rho-container').css('visibility', 'visible').css('display', 'block'); // Visa ρ-fältet
            $('#rho-input').val(''); // Sätt standardvärde till '' när fältet visas
            $('#gas-f1-select-container').css('visibility', 'hidden').css('display', 'none'); // Dölj f1-dropdown för gas
        };
        const uncheckVerticalCheckbox = () => {
            $('#vertical-checkbox').prop('checked', false);
        };
        $('#material-select').on('change', uncheckVerticalCheckbox);
        $('#dn-select').on('change', uncheckVerticalCheckbox);
        $('#temperature-select').on('change', uncheckVerticalCheckbox);
        $('#sdr-select').on('change', uncheckVerticalCheckbox);
        // Hantera materialval
        $('#material-select').on('change', (event) => {
            resetGasCheckbox();  // Återställ checkbox och fält
            let selectedMaterial = $(event.target).val();
            this.resetSelections();  // Återställ alla val
            if (selectedMaterial) {
                this.loadDnValues(selectedMaterial);  // Ladda DN-värden för valt material
                $('#dn-select').prop('disabled', false);  // Aktivera DN när material är valt
            } else {
                $('#dn-select').prop('disabled', true);  // Inaktivera DN om material inte är valt
            }
            this.$('#clamping-result').empty();  // Töm resultatet när material ändras
        });


        // Hantera DN-val
        $('#dn-select').on('change', (event) => {
            resetGasCheckbox();  // Återställ checkbox och fält
            let selectedMaterial = $('#material-select').val();
            let selectedDn = $(event.target).val();
            this.$('#temperature-select').empty().prop('disabled', true);  // Återställ och inaktivera Temperatur
            this.$('#sdr-select').empty().prop('disabled', true).hide();  // Återställ och inaktivera PN
            $('#rho-container').hide();  // Dölj ρ-fältet
            $('#rho-input').val('');  // Rensa ρ-värdet
            this.$('#clamping-result').empty();  // Töm resultatet

            if (selectedMaterial && selectedDn) {
                this.loadTemperatureValues(selectedMaterial, selectedDn);  // Ladda temperaturvärden för valt DN
                $('#temperature-select').prop('disabled', false);  // Aktivera temperatur-dropdown
            }
        });
        // Hantera temperaturval
        $('#temperature-select').on('change', () => {
            resetGasCheckbox();  // Återställ checkbox och fält
            let selectedMaterial = $('#material-select').val();
            let selectedDn = $('#dn-select').val();
            let selectedTemperature = $('#temperature-select').val();

            this.$('#sdr-select').empty().prop('disabled', true).hide();  // Återställ och inaktivera PN
            $('#rho-container').hide();  // Dölj ρ-fältet
            $('#rho-input').val('');  // Rensa ρ-värdet
            this.$('#clamping-result').empty();  // Töm resultatet

            if (selectedMaterial && selectedDn && selectedTemperature) {
                let result = this.calculateClampingDistance();  // Beräkna första värdet från tabellen
                this.$('#table-clamp-value').val(result);  // Visa resultatet
                this.loadPnValues(selectedMaterial, selectedDn);  // Ladda PN-värden
                $('#sdr-select').prop('disabled', false).show();  // Aktivera PN-dropdown, men visa inte f1-dropdown
            }
        });


        // Hantera PN-val och synkronisera PN(gas)
        $('#sdr-select').on('change', (event) => {
            let selectedSdr = $(event.target).val();
            let isGasChecked = $('#gas-checkbox').is(':checked');  // Kontrollera om checkboxen är ikryssad

            // Om inget PN är valt (tömning), rensa PN(gas) och resultatet
            if (!selectedSdr) {
                $('#gas-f1-select').val('');  // Töm PN(gas)
                $('#clamping-result').empty();  // Töm resultatet
                return;  // Avsluta funktionen tidigt
            }
            let selectedMaterial = $('#material-select').val();
            let f2Value = this.sdrData[selectedMaterial][selectedSdr] || 'Okänt värde';
            $('#f2-value').val(f2Value); // Uppdatera f2-value

            // Rensa f1-value eftersom det inte ska visas förrän gas-checkboxen är markerad
            $('#f1-value').val('');
            // Rensa ρ-fältet när PN ändras
            $('#rho-input').val('');  // Töm fältet

            // Synka gas-f1-dropdown med valt PN när checkboxen för gas är markerad
            if (isGasChecked) {
                let f1Value = this.f1Data[selectedMaterial][selectedSdr] || 'Okänt värde'; // Hämta nytt f1-värde
                $('#f1-value').val(f1Value); // Uppdatera f1-fältet
                this.displayFinalClampingDistance(); // Uppdatera slutresultatet
            } else {
                $('#f1-value').val(''); // Töm f1 om Gas-checkboxen inte är markerad
                $('#rho-input').val(''); // Återställ ρ till standardvärde
            }

            // Visa eller dölj rätt fält baserat på checkboxens status
            if (!isGasChecked) {
                $('#rho-container').css('visibility', 'visible').css('display', 'block');  // Visa ρ-fältet
                $('#rho-input').val('');
                $('#f1-value').val();
                this.displayFinalClampingDistance();
                $('#gas-f1-select-container').css('visibility', 'hidden').css('display', 'none');  // Dölj f1-dropdown för gas
            } else {
                $('#rho-container').css('visibility', 'hidden').css('display', 'none');  // Dölj ρ-fältet
                $('#gas-f1-select-container').css('visibility', 'visible').css('display', 'flex');  // Visa f1-dropdown för gas
            }

            // Kontrollera om materialet stödjer gas och visa gas-checkboxen
            if (this.isGasMaterial($('#material-select').val())) {
                $('#gas-checkbox-container').css('visibility', 'visible').css('display', 'block');
            }

            // Om ett PN är valt, beräkna stödavstånd och uppdatera resultatet
            if (selectedSdr) {
                let selectedMaterial = $('#material-select').val();
                let f2 = this.getF2Value(selectedMaterial, selectedSdr);  // Hämta f2-värdet
                let result = this.calculateClampingDistance();  // Hämta första värdet från tabellen

                // Om gas-checkbox är markerad, beräkna och visa resultatet för gas
                if (isGasChecked) {
                    // Hämta korrekt f1-värde från f1Data
                    let f1 = this.f1Data[selectedMaterial][selectedSdr];  // Använd samma logik som vid checkbox-klick
                    $('#f1-value').val(f1);

                    let finalClampingDistance = Math.round(result * f2 * f1);  // Multiplicera och avrunda resultatet
                    this.$('#clamping-result').html(`<h3>Stödavstånd (Gas): ${finalClampingDistance} mm</h3>`);
                } else {
                    // Visa vanligt resultat utan gasberäkningar
                    this.$('#clamping-result').html(`<h3>Värde från tabell: ${result}</h3>`);
                }
            }
        });



        $('#gas-checkbox').on('change', () => {
            this.toggleVerticalCheckboxVisibility();
            this.toggleF1ContainerVisibility();
            let isChecked = $('#gas-checkbox').is(':checked');
            let selectedSdr = $('#sdr-select').val();  // Hämta valt PN
            let selectedMaterial = $('#material-select').val();  // Hämta valt material

            // Rensa resultatet när checkboxen ändras
            $('#clamping-result').empty();  // Töm resultatet

            if (isChecked) {
                $('#gas-f1-select').css('color', '#e9ecef');
                // Dölj ρ-fältet och visa f1-dropdownen för gas
                $('#rho-container').css('visibility', 'hidden').css('display', 'none');
                $('#gas-f1-select-container').css('visibility', 'visible').css('display', 'flex');
                // Kontrollera och sätt rätt f1-värde
                if (selectedMaterial && selectedSdr) {
                    let f1Value = this.f1Data[selectedMaterial][selectedSdr] || 1; // Hämta f1 från f1Data
                    $('#f1-value').val(f1Value); // Visa f1-värdet
                }
                // Kontrollera och ladda alternativ till PN(gas) om de inte finns
                if ($('#gas-f1-select').find('option').length === 0) {
                    $('#sdr-select option').clone().appendTo('#gas-f1-select');
                }

                // Synka värdet mellan sdr-select och gas-f1-select
                $('#gas-f1-select').val(selectedSdr);  // Sätt samma värde som PN
                $('#gas-f1-select').trigger('change.select2');  // Uppdatera select2 för visning

                // Hämta rätt `f1` från `f1Data` baserat på valt material och SDR
                let f1 = this.f1Data[selectedMaterial][selectedSdr] || 1;  // Om f1 saknas, använd standardvärdet 1
                this.displayFinalClampingDistance(f1);  // Anropa funktionen med rätt f1 för gas
            } else {
                $('#gas-f1-select').css('color', '#495057');
                // mirror the value that is inside rho input in f1-value
                $('#clamping-result').val('');
                // Återställ stilen och visa ρ-fältet
                $('#gas-f1-select').css({
                    'pointer-events': 'auto',
                    'background-color': '',
                    'opacity': ''
                });

                $('#rho-container').css('visibility', 'visible').css('display', 'block');
                $('#rho-input').val('');
                $('#f1-value').val($('#rho-input').val());

                this.displayFinalClampingDistance();
                $('#gas-f1-select-container').css('visibility', 'hidden').css('display', 'none');

                // Om checkboxen inte är markerad, beräkna `f1` från ρ-värdet om det finns
                let rho = parseFloat($('#rho-input').val());
                let f1 = isNaN(rho) ? 1 : this.calculateF1(rho);

                // Om ρ saknas, använd standardvärdet 1
                this.displayFinalClampingDistance(f1);  // Visa slutgiltigt stödavstånd
            }
        });


        $('#rho-input').on('input', (event) => {
            this.toggleF1ContainerVisibility();
            const inputField = $(event.target);
            const rawValue = inputField.val();
            const numericValue = parseFloat(rawValue);

            if (rawValue === '' || isNaN(numericValue)) {
                $('#clamping-result').val('');
                $('#f1-value').val('');
                return;
            }

            if (numericValue < 0.6) {
                $('#clamping-result').val('');
                let f1 = this.calculateF1(0.6);
                $('#f1-value').val(f1.toFixed(3));
                this.displayFinalClampingDistance(0.6);
            } else if (numericValue > 4.0) {
                $('#rho-input').val(4.0);
                let f1 = this.calculateF1(4.0);
                $('#f1-value').val(f1.toFixed(3));
                this.displayFinalClampingDistance(4);

            } else {
                let f1 = this.calculateF1(numericValue);
                this.displayFinalClampingDistance(f1);
                $('#f1-value').val(this.calculateF1(numericValue).toFixed(3));
            }

        });

        // Validate rho-input on blur
        $('#rho-input').on('blur', () => {
            let rho = parseFloat($('#rho-input').val());
            if (!isNaN(rho)) {
                if (rho < 0.6) {
                    rho = 0.6;
                    $('#f1-value').val(this.calculateF1(0.6).toFixed(3));
                } else if (rho > 4.0) {
                    rho = 4.0;
                    $('#f1-value').val(this.calculateF1(4.0).toFixed(3));
                }
                $('#rho-input').val(rho);
                $('#f1-value').val(this.calculateF1(rho).toFixed(3));

            }
        });

        // Förhindra att "Enter" skickar formuläret
        $('#rho-input').on('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        });

        // Hantera f1-val för gas
        $('#gas-f1-select').on('change', () => {
            let selectedF1Value = parseFloat($('#gas-f1-select').val());  // Använd valt värde
            this.displayFinalClampingDistance(selectedF1Value);  // Visa slutgiltigt resultat baserat på valt f1

        });

        $('#vertical-checkbox').on('change', () => {
            let f1 = parseFloat($('#gas-f1-select').val()) || this.calculateF1(parseFloat($('#rho-input').val()) || 1);
            this.displayFinalClampingDistance(f1);  // Visa om stödavståndet baserat på 30% justering
        });
        // Anropa toggle-funktionen vid ändring av fält
        $('#material-select, #dn-select, #temperature-select, #sdr-select').on('change', () => {
            this.toggleVerticalCheckboxVisibility();  // Kontrollera synligheten för vertikal-checkbox
        });


        $(document).on("click", ".generate-pdf-clamp", function (e) {
            e.preventDefault();

            var $bounds = $(".block-clamping-distance");
            var $logo = $(".g-logo");

            // Visa logotypen

            // Lägg till en fördröjning på 1 sekund
            $bounds.LoadingOverlay("show", {
                imageClass: "jquery-loading-overlay-icon",
                image: ajax.templateUrl + "/assets/svg/loading.svg",
                imageResizeFactor: 1,
                zIndex: 800,
                background: "rgba(255, 255, 255, 1)"
            });
            $logo.css("display", "block");
            setTimeout(function () {
                $bounds.addClass("generating");


                html2PDF($bounds, {
                    jsPDF: {
                        format: "a4"
                    },
                    imageType: "image/jpeg",
                    output: "support_distance" + Math.floor(Math.random() * 99999) + ".pdf",
                    success: function (pdf) {
                        $bounds.LoadingOverlay("hide");
                        $bounds.removeClass("generating");
                        pdf.save(this.output);

                        // Dölj logotypen igen efter generering
                        $logo.css("display", "none");
                    }
                });
            }, 200);
        });




        $(document).on("click", ".clear-values-clamp", function (e) {
            e.preventDefault();
            $('#material-select').val('').trigger('change');
            $('#dn-select').val('').trigger('change');
            $('#temperature-select').val('').trigger('change');
            $('#sdr-select').val('').trigger('change');
            $('#rho-input').val('');
            $('#gas-checkbox').prop('checked', false).trigger('change');
            $('#vertical-checkbox').prop('checked', false).trigger('change');
            $('#clamping-result').empty();
            $('#f2-value').val('');
            $('#f1-value').val('');
            $('#table-clamp-value').val('');

            $('#rho-container').css('visibility', 'hidden').css('display', 'none');
        });



    }

    // updateClampingResultWithVerticalSupport(isChecked) {
    //     let resultText = this.$('#clamping-result').text();
    //     let resultMatch = resultText.match(/(\d+) mm/);

    //     if (resultMatch) {
    //         let originalResult = parseInt(resultMatch[1]);
    //         let adjustedResult = isChecked ? Math.round(originalResult * 1.3) : originalResult;

    //         this.$('#clamping-result').html(
    //             `<h3>Stödavstånd: ${adjustedResult} mm</h3>`
    //         );
    //     }
    // }
    toggleF1ContainerVisibility() {
        const isGasChecked = this.$('#gas-checkbox').is(':checked');
        const rhoValue = parseFloat(this.$('#rho-input').val());

        if (isGasChecked || (!isNaN(rhoValue) && rhoValue > 0)) {
            this.$('#f1-container').css('visibility', 'visible').css('display', 'block');
        } else {
            this.$('#f1-container').css('visibility', 'hidden').css('display', 'none');
        }
    }

    toggleVerticalCheckboxVisibility() {
        let rhoValue = parseFloat($('#rho-input').val());
        let isGasChecked = $('#gas-checkbox').is(':checked');

        if (!isNaN(rhoValue) || isGasChecked) {
            $('#vertical-checkbox-container').css('display', 'flex');  // Visa checkboxen med display: flex
        } else {
            // $('#vertical-checkbox-container').css('display', 'none');  // Dölj checkboxen
        }
        // $('#f1-value').val($('#rho-input').val());
    }
    // Ny funktion för att synkronisera "PN(gas)" med valt "SDR"
    syncGasPnWithselectedSdr(selectedSdr) {
        let $f1Select = this.$('#gas-f1-select');
        $f1Select.val(this.f1Data[$('#material-select').val()][selectedSdr]).trigger('change');  // Sätt värdet för f1 baserat på valt PN
    }

    // Kontrollera om materialet har gas-alternativ
    isGasMaterial(material) {
        return ['ECTFE', 'PE', 'PP', 'PVC', 'CPVC', 'PVDF'].includes(material);
    }

    // Kontrollera om materialet har f1-värden för gas
    hasGasF1Values(material) {
        return !!this.f1Data[material];
    }

    // Ladda f1-värden för gas i dropdownen
    loadGasF1Values(selectedMaterial) {
        let $f1Select = this.$('#gas-f1-select');
        // $f1Select.empty().prop('disabled', false);  // Töm dropdownen och aktivera den
        $f1Select.append(`<option></option>`);  // Placeholder-alternativ

        if (this.f1Data[selectedMaterial]) {
            Object.keys(this.f1Data[selectedMaterial]).forEach(pn => {
                // Visa endast PN-numret och lagra f1-värdet som en data-attribut
                $f1Select.append(`<option value="${this.f1Data[selectedMaterial][pn]}" data-f1="${this.f1Data[selectedMaterial][pn]}">${pn}</option>`);
            });
        }

        $f1Select.select2({
            placeholder: "Välj PN",
            allowClear: true
        });
    }
    displayResults(f1) {
        let selectedMaterial = this.$('#material-select').val();
        let selectedDn = this.$('#dn-select').val();
        let selectedTemperature = this.$('#temperature-select').val();
        let result = this.calculateClampingDistance();  // Hämta första värdet
        let selectedSdr = $('#sdr-select').val();
        let f2 = this.getF2Value(selectedMaterial, selectedSdr);  // Hämta f2

        // Visa alla värden

        $('#clamping-result').val(result);
    }
    // Beräkna stödavstånd (det första värdet, t.ex. 2000)
    calculateClampingDistance() {
        let selectedMaterial = this.$('#material-select').val();
        let selectedDn = this.$('#dn-select').val();
        let selectedTemperature = this.$('#temperature-select').val();

        // Ta bort "°C" från temperaturen och omvandla till ett heltal
        let temperatureValue = selectedTemperature ? parseInt(selectedTemperature.replace('°C', '')) : null;


        if (selectedMaterial && selectedDn && temperatureValue) {
            return this.getClampingDistance(selectedMaterial, selectedDn, temperatureValue);  // Skicka rätt värden
        }
        return 'Okänt värde';
    }

    displayFinalClampingDistance() {
        let rhoValue = parseFloat($('#rho-input').val());
        let selectedF1Value = parseFloat($('#gas-f1-select').val());

        // Ensure either rho-input or gas-f1-select has a value
        if (isNaN(rhoValue) && isNaN(selectedF1Value)) {
            this.$('#clamping-result').val(''); // Clear the result if neither has a value
            return;
        }

        if (rhoValue < 0.6) {
            rhoValue = 0.6;
        } else if (rhoValue > 4.0) {
            rhoValue = 4.0;
        }
        let isGasChecked = $('#gas-checkbox').is(':checked');
        let isVerticalChecked = $('#vertical-checkbox').is(':checked'); // Vertikal checkbox

        // Standardisera \(\rho\) till 1 om den är tom eller ogiltig
        if (isNaN(rhoValue) || rhoValue === '') {
            rhoValue = 1;
        }

        let selectedMaterial = this.$('#material-select').val();
        let selectedDn = this.$('#dn-select').val();
        let selectedTemperature = this.$('#temperature-select').val();
        let result = this.calculateClampingDistance();
        let selectedSdr = $('#sdr-select').val();
        let f2 = this.getF2Value(selectedMaterial, selectedSdr);
        //if no values return

        if (!selectedMaterial || !selectedDn || !selectedTemperature || !selectedSdr) {
            this.$('#clamping-result').val('');
            return;
        }
        // Beräkna \(f_1\) och slutligt stödavstånd
        let f1 = isGasChecked
            ? this.f1Data[selectedMaterial]?.[selectedSdr] || 1
            : this.calculateF1(rhoValue);

        // Om något värde är ogiltigt, logga och avbryt
        if (isNaN(result) || isNaN(f2) || isNaN(f1)) {
            console.warn('Ogiltiga värden för beräkning:', { result, f2, f1 });
            this.$('#clamping-result').val(''); // Rensa resultat
            return; // Avbryt funktionen
        }

        let finalClampingDistance = Math.round(result * f2 * f1);

        // Justera för vertikal checkbox
        if (isVerticalChecked) {
            finalClampingDistance = Math.round(finalClampingDistance * 1.3);
        }

        // Visa resultatet
        this.$('#clamping-result').val(finalClampingDistance);

    }


    calculateF1(rho) {
        return (1.16 - 0.16 * rho);  // Beräkna f1 utan avrundning av rho
    }

    // Hämta klamringsavståndet från den hårdkodade datan
    getClampingDistance(material, dn, temperature) {
        if (this.data[material] && this.data[material][dn] && this.data[material][dn][temperature]) {
            return this.data[material][dn][temperature];  // Returnera värdet (t.ex. 2000)
        }
        return 'Okänt värde';
    }

    loadDnValues(material) {
        let $dnSelect = this.$('#dn-select');
        $dnSelect.empty().prop('disabled', false); // Rensa tidigare val och aktivera

        // Lägg till en placeholder för DN-värden
        $dnSelect.append(`<option></option>`); // Placeholder alternativ

        // Fyll DN-värden baserat på valt material från den hårdkodade datan
        Object.keys(this.data[material]).forEach(dn => {
            $dnSelect.append(`<option value="${dn}">${dn}</option>`);
        });

        $dnSelect.select2({
            placeholder: "d (mm)",
            allowClear: true
        });

        // Kontrollera om både materialet är PVDF och DN-värdet är ett specialfall
        $dnSelect.on('change', (event) => {
            let selectedDn = $(event.target).val();
            let selectedMaterial = $('#material-select').val();  // Hämta aktuellt valt material

            if (selectedMaterial === 'PVDF' && ['16', '20', '25', '32', '40', '50'].includes(selectedDn)) {
                // console.log('SPECIAL');  // Logga specialmeddelande till konsolen
            } else {
                // console.log('NOT SPECIAL');  // Logga att det inte är ett specialfall
            }
        });
    }


    loadTemperatureValues(material, dn) {
        let $temperatureSelect = this.$('#temperature-select');
        $temperatureSelect.empty().prop('disabled', false); // Rensa tidigare val och aktivera

        // Lägg till en placeholder för temperaturer
        $temperatureSelect.append(`<option></option>`); // Placeholder alternativ

        // Fyll temperaturer baserat på valt material och DN från den hårdkodade datan
        Object.keys(this.data[material][dn]).forEach(temp => {
            $temperatureSelect.append(`<option value="${temp}">${temp} °C</option>`);  // Visa °C för användaren, men värdet är endast temp som tal
        });

        $temperatureSelect.select2({
            placeholder: "°C",
            allowClear: true
        });
    }


    loadPnValues(material, dn) {
        let $pnContainer = this.$('#sdr-select-container');
        let $pnSelect = this.$('#sdr-select');

        // Visa PN-container
        $pnContainer.show();

        // Rensa tidigare värden och aktivera PN-dropdownen
        $pnSelect.empty().prop('disabled', false);

        // Lägg till en placeholder för PN-värden
        $pnSelect.append(`<option></option>`); // Placeholder option

        // Hämta och sortera PN-värden
        let pnValues = Object.keys(this.sdrData[material]).sort((a, b) => parseFloat(a) - parseFloat(b));

        // Kontrollera om det är ett specialfall (PVDF och ett av DN-värdena 16, 20, 25, 32, 40, 50)
        if (material === 'PVDF' && ['16', '20', '25', '32', '40', '50'].includes(dn)) {
            // Om det är special, filtrera bort PN10 från de sorterade värdena
            pnValues = pnValues.filter(pn => pn !== '10');
        }

        // Lägg till de sorterade (och filtrerade om specialfall) PN-värdena i dropdownen
        pnValues.forEach(pn => {
            $pnSelect.append(`<option value="${pn}">${pn}</option>`);
        });

        // Initiera select2 för att visa dropdown korrekt
        $pnSelect.select2({
            placeholder: "SDR",
            allowClear: true
        });
        this.$('.form-row.second-row').removeClass('d-none');

    }



    getClampingDistance(material, dn, temperature) {

        if (this.data[material] && this.data[material][dn] && this.data[material][dn][temperature]) {
            return this.data[material][dn][temperature];
        }
        return 'Okänt värde';
    }

    getF2Value(material, sdr) {
        // Hämta f2-värdet baserat på material och PN från sdrData
        if (this.sdrData[material] && this.sdrData[material][sdr]) {
            return this.sdrData[material][sdr];
        }
        return 'Okänt f2-värde'; // Returnera om f2 saknas
    }
}

export default ClampingDistance;